import React from 'react'

export const FacebookIcon = ({ className }: { className?: string }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" className={className}>
      <g clipPath="url(#clip0_9559_15927)">
        <path
          d="M23.9999 12.0728C23.9996 9.77963 23.3423 7.53453 22.1057 5.60331C20.8691 3.67209 19.105 2.13563 17.0223 1.17584C14.9397 0.216044 12.6256 -0.126892 10.354 0.187628C8.08251 0.502149 5.94866 1.46095 4.20512 2.95053C2.46158 4.44011 1.18137 6.39808 0.516036 8.59265C-0.149294 10.7872 -0.171875 13.1265 0.450966 15.3335C1.07381 17.5405 2.31599 19.5228 4.03044 21.0457C5.7449 22.5687 7.85984 23.5685 10.1249 23.9268V15.5418H7.07788V12.0728H10.1249V9.42884C10.1249 6.42184 11.9169 4.75984 14.6569 4.75984C15.557 4.77275 16.455 4.85095 17.3439 4.99384V7.94784H15.8299C15.3741 7.88734 14.913 8.01031 14.5479 8.28972C14.1828 8.56913 13.9436 8.98211 13.8829 9.43784C13.8657 9.56546 13.863 9.69461 13.8749 9.82284V12.0728H17.1999L16.6679 15.5418H13.8679V23.9268C16.6919 23.4818 19.2643 22.0432 21.1218 19.8699C22.9793 17.6967 23.9999 14.9317 23.9999 12.0728Z"
          fill="#C4CAD6"
        />
      </g>
      <defs>
        <clipPath id="clip0_9559_15927">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
